import {H2hFetchHandler} from "../../../core/handlers/h2h.fetch-handler";
import {PreviousMeetingsWidgetState} from "../models/previous-meetings-widget.state";

export class PreviousMeetingsWidgetFetchHandler extends H2hFetchHandler {
  state: PreviousMeetingsWidgetState;

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps)

    if(prevProps.shouldFilterByHomeAway !== nextProps.shouldFilterByHomeAway) {
      this.state.isExpanded = false
    }
  }
}
